import React from "react";
import BreadCrumb from "common/breadcrumb";
import BrowserDefault from "./browser-default";
import SignUpForm from "./sign-up-form";


const FormValidation = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Forms Validation" pageTitle="Forms" />
                <BrowserDefault />
                <SignUpForm />
            </div>
        </React.Fragment>
    );
}

export default FormValidation;